import type { ChangeEvent } from 'react';
import { useCallback, useState } from 'react';

const DEFAULT_QUANTITY = '1';

export const useQuantity = () => {
  const [quantity, setQuantity] = useState(DEFAULT_QUANTITY);
  const handleChange = useCallback(
    ({ target: { value } }: ChangeEvent<HTMLSelectElement>) => setQuantity(value),
    []
  );

  return { value: quantity, handleChange };
};
